import React, { useEffect, useState } from 'react';
import { DashboardCards } from '../../components';
import { clientInfoDashboardHeaders, vendorInfoDashboardHeaders } from './utils';
import { useLocation, useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';
import { getUserInfo, updateUserUsage } from './Helper';
import { ArrowBack } from "@mui/icons-material";
import VendorUserList from '../UserManager/Vendor/VendorUserList';
import { useQueryParams } from '../../hooks';
import UsageModal from '../../components/common/UsageModal/UsageModal'; // Import the new modal component
import Swal from 'sweetalert2';

function UserInfoDashboard() {
  const { userid } = useParams();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const vendorRoute = location.pathname.includes("Vendor");
  const { getParam } = useQueryParams();

  const [userDashboardData, setUserDashboardData] = useState({});
  const [modalOpen, setModalOpen] = useState(false);
  const [usageData, setUsageData] = useState({})
  const [userPermissions, setUserPermissions] = useState([]);
  const navigate = useNavigate();
  const context = useOutletContext();
  // Load user data
  const loadUserData = () => {
    getUserInfo(userid, vendorRoute).then((res) => {
      setUserDashboardData(res.data);
      setUsageData(res?.data?.plandetails?.usage?.hasPlan ?  res?.data?.plandetails?.usage?.usage : res?.data?.plandetails?.usage);
    }).catch(err => {
      console.error("Error fetching user info:", err);
    });
  };
  useEffect(() => {
    const cmsPermissions = localStorage.getItem('CMSUsersPermission');
    if (cmsPermissions) {
      setUserPermissions(JSON.parse(cmsPermissions));
    } else {
      setUserPermissions([]);
    }
  }, []);

  useEffect(() => {
    const isMarketplaceRoute = location.pathname.includes("marketplaceJobs");
    const userType = vendorRoute ? "Vendor" : "Client";
    const infoType = vendorRoute ? "Vendor Info" : "Client Info";

    const breadcrumb = ["User Manager", userType, infoType];
    if (isMarketplaceRoute) {
      breadcrumb.push("Marketplace Jobs");
    }

    context(breadcrumb);

    loadUserData();
  }, [userid, location.pathname]);

  const renderUserDashboardCards = (item, index) => {
    return (
      <DashboardCards
        {...userDashboardData[item.key]}
        label={item.label}
        vendorRoute={vendorRoute}
        iconData={{ icon: item.icon, color: item.color }}
        index={index}
      />
    );
  };

  const handlNavigateBacktoVendorList = async () => {
    return navigate(`/UserManager/${vendorRoute ? "Vendor" : "Client"}?page=${getParam("page")}&pageSize=${getParam("pageSize")}`);
  };

  const handleOpenUpdateModal = () => {
    setModalOpen(true);
  };
  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUsageUpdated = async (usageData) => {
    try {
      const dataToSend = {
        ...usageData,
        userId: userid,
        role: vendorRoute ? 'VENDOR' : 'CLIENT',
      };
      
      const response = await updateUserUsage(userid ,  dataToSend);
      if (response?.status === 200) {
        Swal.fire({
          icon: 'success',
          title: 'Usage Updated Successfully',
          confirmButtonText: 'OK',
          timer: 3000,
          timerProgressBar: true,
        });
        
        loadUserData();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Operation Failed',
          text: response.data?.message || 'Something went wrong. Please try again.',
          confirmButtonText: 'OK',
        });
      }
    } catch (error) {
      console.error("Error saving usage:", error);
      Swal.fire({
        icon: 'error',
        title: 'Operation Failed',
        text: 'An unexpected error occurred. Please try again later.',
        confirmButtonText: 'OK',
      });
    }
  };

  const userName = searchParams.get("user-name") || "";

  return (
    <div className='flex flex-col'>
      <div className="flex justify-between py-4 px-6">
        <button
          className='pl-2 pr-4 py-2 bg-[#2EBAA3] rounded-md text-[#fff]'
          onClick={handlNavigateBacktoVendorList}
        >
          <ArrowBack sx={{ marginRight: "8px" }} /> Go Back
        </button>

      </div>

      <div className="flex justify-between pl-6 pb-4">
        <h1 className='text-3xl'>{userName} Overview</h1>
        {!userPermissions.includes('sales-access') && (
        <div className='pr-8'>
              <button
                className='px-4 py-2 bg-green-500 hover:bg-green-600 rounded-md text-white transition duration-200 font-semibold'
                onClick={handleOpenUpdateModal}
              >
                Update Usage
              </button>
        </div>
        )}
      </div>

      <div className="flex flex-wrap justify-start pl-6">
        {(vendorRoute ? vendorInfoDashboardHeaders : clientInfoDashboardHeaders).map(renderUserDashboardCards)}
      </div>

      <VendorUserList isChildUser={true} />

      {/* Usage Modal */}
      <UsageModal
        open={modalOpen}
        handleClose={handleCloseModal}
        userType={vendorRoute ? 'vendor' : 'client'}
        initialUsage={usageData}
        onSave={handleUsageUpdated}
      />
    </div>
  );
}

export default UserInfoDashboard;